<header class="fixed top-0 z-50 flex h-14 w-full justify-between border-b border-zinc-100 bg-white py-4 lg:h-18">
  <nav class="container flex items-center justify-between px-5">
    <!-- 로고 + 연계사이트 드롭다운 -->
    <div class="flex items-center gap-1">
      <a routerLink="/" class="cursor-pointer">
        <img
          [src]="logoData()?.value || '/logo.svg'"
          alt="마이스좋은공간 로고"
          class="bg-cover bg-center bg-no-repeat w-24" />
      </a>

      <!-- PC: 드롭다운 버튼 (연계사이트) -->
      <div class="relative hidden lg:block" (mouseenter)="openDropdown()" (mouseleave)="closeDropdown()">
        <button
          type="button"
          class="flex items-center justify-center w-7 h-7 rounded-full transition-colors duration-200 cursor-pointer hover:bg-zinc-200">
          <app-icon
            name="material-symbols:keyboard-arrow-down-rounded"
            class="size-5! text-zinc-600 transition-transform duration-300"
            [class.rotate-180]="isDropdownOpen()" />
        </button>

        <!-- 드롭다운 패널 -->
        @if (isDropdownOpen()) {
        <div class="absolute top-full left-1/2 -translate-x-1/2 pt-3 z-50">
          <div class="w-fit bg-white/70 backdrop-blur-md rounded-2xl shadow-lg border border-white/40 overflow-hidden">
            <div class="py-2">
              @for (site of relatedSites; track $index) {
              <a
                [href]="site.url"
                target="_blank"
                rel="noopener noreferrer"
                (click)="closeDropdown()"
                class="flex items-center px-4 py-2.5 text-sm text-zinc-800 hover:bg-zinc-50 hover:text-primary-500 transition-colors duration-150 font-medium whitespace-nowrap">
                {{ site.label }}
              </a>
              }
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="flex gap-2.5 items-center lg:hidden">
      <button type="button" (click)="onMenuClick()" class="cursor-pointer flex items-center">
        <app-icon name="material-symbols:menu-rounded" class="size-5! text-zinc-800" />
      </button>
    </div>

    <!-- lg 이상: 상단 메뉴 -->
    <div class="hidden gap-9 lg:flex items-center">
      @for (item of navItems; track i; let i = $index) { @if (item.path === '/inquiry') {
      <a
        class="flex items-center gap-1 text-white bg-[#820D20] cursor-pointer font-medium px-3 py-2 rounded-full"
        [routerLink]="[item.path]">
        {{ item.label }}
        <app-icon name="material-symbols:arrow-outward-rounded" class="size-5! text-white" />
      </a>
      } @else {
      <a class="cursor-pointer font-medium px-4 text-zinc-800" [routerLink]="[item.path]">
        {{ item.label }}
      </a>
      } }
    </div>
  </nav>
</header>
